export const PURCHASE_TYPE = {
  VOUCHER: 'voucher',
  BOOKING: 'booking',
  GIFTCARD: 'giftcard',
};

export const EXTRA_SERVICES_PRICE_TYPES = {
  PERSON: 'person',
  GROUP: 'group',
};

export const BOOKING_FORM_TABS = {
  BOOKING: 'BOOKING',
  PRESENT: 'PRESENT',
  GIFTCARD: 'GIFTCARD',
  NOTAB: 'NOTAB',
};

export const STEPS = {
  DATETIME_SELECT: 'DATETIME_SELECT',
  PARTICIPANTS_SELECT: 'PARTICIPANTS_SELECT',
  PERSONALIZE_PRESENT: 'PERSONALIZE_PRESENT',
};

export const PARTICIPANTS_SELECTION_TYPES = {
  TOP: 'top',
  TOP3: 'top3',
  FIXED: 'fixed',
  VARIABLE: 'variable',
  GROUP: 'group',
};

export const BOOKABLE_UNITS_SELECTOR = {
  TOP1: 'top1',
  PARTICIPANTS: 'participants',
  GROUP: 'group',
};

export const BREAKPOINTS = {
  MBL_LANDSCAPE: 568,
  SMALL_TABLET: 640,
  TABLET: 940,
  TABLET_LANDSCAPE: 1024,
  MBL_HEADER: 1042,
  LAPTOP: 1280,
};

export const DROPDOWN_POSITIONS = {
  LEFT: 'DROPDOWN_LEFT',
  RIGHT: 'DROPDOWN_RIGHT',
  CENTER: 'DROPDOWN_CENTER',

  LOGIN: 'LOGIN',
  NAVBAR: 'NAVBAR',
  NAVBAR_SECONDARY: 'NAVBAR_SECONDARY',
};

export const DROPDOWN_MBL_BEHAVIOUR = {
  BOTTOM_FROM_MBL_LANDSCAPE: 'BOTTOM_FROM_MBL_LANDSCAPE',
  BOTTOM_FROM_TABLET: 'BOTTOM_FROM_TABLET',
  NONE: 'NONE',
};

export const ORDER_BY = {
  SUGGESTED_ACTIVITIES: 'SUGGESTED_ACTIVITIES',
  PRICE_ASC: 'PRICE_ASC',
  PRICE_DESC: 'PRICE_DESC',
  PROXIMITY: 'PROXIMITY',
  REVIEWS: 'REVIEWS',
};

export const BADGE_TYPES = {
  SUCCESS: 'success',
  DANGER: 'danger',
  WARNING: 'warning',
};

export const QUERY_PARAMS = {
  SEARCH_TERM: 'searchTerm',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  ALWAYS: 'isAlways',
  NEXT_MONTH: 'isNextMonth',
  CATEGORIES: 'category',
};

export const DATE_FORMATS = {
  SEARCH_FORM_FE_VISUALIZATION: 'D MMM',
  SEARCH_FORM_BE_VISUALIZATION: 'YYYY-MM-DD',
  REVIEWS_INSERTION_PAGE: 'D/MM/YYYY',
  USER_FORM_FE: 'DD/MM/YYYY',
};

export const ROLES = {
  CUSTOMER: 'customer',
  PARTNER: 'partner',
  AFFILIATE: 'affiliate',
};

export const SESSION_STORAGE_KEYS = {
  PENDING_ACTIONS: 'pendingActions',
};

export const TOOLTIP_POSITIONS = {
  TOP: 'top',
  RIGHT: 'right',
  BOTTOM: 'bottom',
  LEFT: 'left',
};

export const REVIEW_ORDER = {
  MOST_RELEVANT: 'MOST_RELEVANT',
  MOST_RECENT: 'MOST_RECENT',
  LESS_RECENT: 'LESS_RECENT',
  HIGHEST_RATED: 'HIGHEST_RATED',
  LOWEST_RATED: 'LOWEST_RATED',
};

export const ACCEPTED_MEDIA = {
  'image/jpg': ['.jpg'],
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/gif': ['.gif'],
  'image/webp': ['.webp'],
  'video/mp4': ['.mp4'],
  'video/webm': ['.webm'],
  'video/avi': ['.avi'],
  'video/mov': ['.mov'],
};

export const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.avi', '.mov'];

export const IMAGE_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.webp'];

export const voucherPreviewModalWidth = 470;

export const GIFTCARD_COVER_URL = 'images/new/gift-card-carousel/42.jpg';

export const REVIEW_PROVIDERS = ['google', 'tripadvisor'];

export const returnHubspotCustomerFormId = (() => {
  switch (freedomeConfig.environment) {
    case 'production':
      return '09d42f28-7823-4be5-942f-0831c8ab5496';
    case 'production-es':
      return '09d42f28-7823-4be5-942f-0831c8ab5496';
    default:
      return 'a5cde62b-26bc-4c94-bdd8-7f89164801d8';
  }
})();

export const returnHubspotContactUsFormId = (type) => {
  if (
    freedomeConfig.environment === 'local' ||
    freedomeConfig.environment === 'staging' ||
    freedomeConfig.environment === 'staging-es'
  ) {
    return 'a5cde62b-26bc-4c94-bdd8-7f89164801d8';
  }

  switch (freedomeConfig.baseLocale) {
    case 'it':
      switch (type) {
        case 'no-booking':
          return 'e61b51eb-ad33-4fed-8de5-c435881f9c9c';
        case 'booking':
          return '09d42f28-7823-4be5-942f-0831c8ab5496';
        case 'profile':
          return '37d8d63e-1f23-4b3e-8908-3c6e475a6db7';
        default:
          return 'e61b51eb-ad33-4fed-8de5-c435881f9c9c';
      }
    case 'es':
      switch (type) {
        case 'no-booking':
          return 'e61b51eb-ad33-4fed-8de5-c435881f9c9c';
        case 'booking':
          return '09d42f28-7823-4be5-942f-0831c8ab5496';
        case 'profile':
          return '37d8d63e-1f23-4b3e-8908-3c6e475a6db7';
        default:
          return 'e61b51eb-ad33-4fed-8de5-c435881f9c9c';
      }
    default:
      return 'a5cde62b-26bc-4c94-bdd8-7f89164801d8';
  }
};
